
import { csmsApiGet, csmsApiPost } from '../../apis/api';
import { GET_CHARGING_LIST, GET_CSMS_API_KEY, GET_CSMS_CHARGER, GET_USER, POST_CSMS_MEMBERCARD_REQUEST, POST_CSMS_REPAY_USER, POST_CSMS_SOC_SETTING, POST_CSMS_STIPULATION_USER, REGIST_USER, UPDATE_USER_INFO } from './types';

export const csmsGetApiKey = () => {
    const request = csmsApiPost("/auth/api-key", {
        "apiKey": process.env.REACT_APP_CSMS_API_KEY
    }).then(response => response);

    return {
        type: GET_CSMS_API_KEY,
        payload: request
    }
}

export const csmsGetChargingRecord = (id, token) => {
    const request = csmsApiGet("/external/qr/charging/" + id, {
        headers: {
            "Authorization": "Bearer " + token
        },
        timeout: 3000,
    }).then(response => response);

    return {
        type: GET_CSMS_CHARGER,
        payload: request
    }
}

export const csmsSetChargingTarget = (data, token) => {
    const request = csmsApiPost("/seoulev/remote/charging-target", data, {
        headers: {
            "Authorization": "Bearer " + token
        },
        timeout: 3000,
    }).then(response => response);

    return {
        type: POST_CSMS_SOC_SETTING,
        payload: request
    }
}

export const csmsRegistUser = (data, token) => {
    const request = csmsApiPost("/users", data, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => response);

    return {
        type: REGIST_USER,
        payload: request
    }
}

export const csmsGetUser = (id, token) => {
    const request = csmsApiGet("/users/" + id, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => response);

    return {
        type: GET_USER,
        payload: request
    }
}

export const csmsRequestMembercard = (data, token) => {
    const request = csmsApiPost("/user-cards/membercard-request", data, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => response);

    return {
        type: POST_CSMS_MEMBERCARD_REQUEST,
        payload: request
    }
}

export const csmsUpdateUserCar = (id, userCarId, data, token) => {
    const request = csmsApiPost("/users/" + id + "/" + userCarId, data, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => response);

    return {
        type: UPDATE_USER_INFO,
        payload: request
    }
}

export const csmsUpdateUser = (id, data, token) => {
    const request = csmsApiPost("/users/" + id, data, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => response);

    return {
        type: UPDATE_USER_INFO,
        payload: request
    }
}

export const csmsGetChargingList = (id, data, token) => {
    const request = csmsApiGet(`/users/${id}/chrgr-elctc`, {
        headers: {
            "Authorization": "Bearer " + token
        },
        params: data,
    }).then(response => response);

    return {
        type: GET_CHARGING_LIST,
        payload: request
    }
}

export const csmsRepayUser = (userId, token) => {
    const request = csmsApiPost("/elctc-payments/repay-user", { userId: parseInt(userId) }, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => response);

    return {
        type: POST_CSMS_REPAY_USER,
        payload: request
    }
}

export const csmsPostStipulationUser = (userId, data, token) => {
    const request = csmsApiPost("/stipulation-users/" + userId, data, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => response);

    return {
        type: POST_CSMS_STIPULATION_USER,
        payload: request
    }
}